import { defineStyle, defineStyleConfig, ComponentStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  borderRadius: 'lg'
});

const variants = defineStyle({
  outline: {
    bgColor: 'chakra-body-bg',
    borderRadius: 'lg',
    borderWidth: '2px'
  }
});

export const textareaTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle,
  variants
});
